<template>
  <BaseButton
    icon
    variant="ghost"
    size="small"
    aria-label="info"
  >
    <InfoIcon />
  </BaseButton>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import InfoIcon from '@shared/assets/icon/InfoIcon.vue'
</script>
